module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Scissors-e4784d3bc3af7602daac5dfbd23fedab.svg";